// Copyright (c) 2022 by Move Closer

import { SelectItem } from '../../../../dsl/atoms/Select'

import { FormFieldsetData } from '../../../shared/contracts/forms'
import { AnyObject } from '@movecloser/front-core'

export const ADDRESS_FORM_FIELDSET_COMPONENT_KEY = 'AddressFormFieldsetComponent'

export const defaultComponentConfig: AnyObject = {
  isCountrySelectEnable: false,
  isPostalCodeRequired: true,
  isShipmentLabelActive: true
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface AddressFormData {
  /**
   * Delivery address
   */
  address: string

  /**
   * Billing address of delivery.
   */
  billingAddress: AddressFormFieldsetBillingAddressData

  /**
   * Delivery address's city
   */
  city: string
  /**
   * Delivery address company
   */
  company: string
  /**
   * Delivery address's country
   */
  country: string
  /**
   * Invoice data.
   */
  invoice?: {
    /**
     * Company name
     */
    company: string

    /**
     * NIP.
     */
    nip: string
  }

  /**
   * Phone for delivery
   */
  phone: string

  /**
   * Delivery address postal code
   */
  postalCode: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface AddressFormFieldsetProps extends FormFieldsetData<AddressFormData> {
  /**
   * Form field errors.
   */
  _errors: Record<string, string[]> | null
  /**
   * List of countries to deliver.
   */
  countries: SelectItem[]
  /**
   * Wheteher invoice form should be visible.
   */
  hasInvoice?: boolean
  /**
   * Whether shipping and billing address should be the same.
   */
  sameBillingAddress?: boolean
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type AddressFormFieldsetBillingAddressData = Pick<AddressFormData, 'address' | 'postalCode' | 'city'>
